import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Player from "./playerInfo/Player";
import { app, api } from "../app";
import PlayerRescueList from "./playerInfo/PlayerRescueList";
import PlayerRescueDetail from "./playerInfo/PlayerRescueDetail";
import PlayerTrainList from "./playerInfo/PlayerTrainList";
import PlayerTrainDetail from "./playerInfo/PlayerTrainDetail";
import InfoEdit from "./playerInfo/InfoEdit";
import UpPwd from "./playerInfo/UpPwd";
import SkillAdd from "./playerInfo/SkillAdd";
// import '../css/players.css'
// import '../css/player.css'
import "../css/member.css";
import MyFrame from "../components/Frame";
import PMember from "./playerInfo/PMember";
import PExperience from "./playerInfo/PExperience";
import TeamHonorWall from "./ranks/TeamMore/TeamHonorWall";
import UserReport from "./playerInfo/UserReport";
import UserAddress from "./playerInfo/UserAddress";

function checkMenu(path) {
  let key = "1";
  switch (path) {
    case "/player/infoedit":
      key = "2";
      break;
    case "/player/uppwd":
      key = "3";
      break;
    case "/player/add-skill":
      key = "4";
      break;
    case "/player/user-report":
      key = "5";
      break;
    case "/player/user-address":
      key = "7";
      break;

  }
  return key;
}

class PlayerInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tToken: "",
      menu_key: checkMenu(props.location.pathname),
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getTokeni();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * 获取token
   * @returns {Promise<void>}
   */
  getTokeni = async () => {
    let { flag, data, msg } = await app.post(api.getToken);
    if (flag === 1) {
      this.setState({
        tToken: data.token,
      });
    } else {
      app.alert(msg, "warn");
    }
  };

  /**
   * 设置值
   * @param data
   */
  setData = (data) => app.setStateSync(this, data);

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setData({ menu_key: checkMenu(nextProps.location.pathname) });
    }
  }

  render() {
    const token = app.getToken(),
      { menu_key, tToken } = this.state,
      menuList = [
        {
          key: "1",
          text: "个人页面",
          link: `/player/${app.getData("team_id")}/${app.getData(
            "indexno"
          )}?token=${tToken}`,
        },
      ],
      nodeList = [];
    if (token) {
      menuList.push(
        { key: "2", text: "个人信息编辑", link: "/player/infoedit" },
        { key: "3", text: "修改密码", link: "/player/uppwd" },
        { key: "4", text: "个人技能", link: "/player/add-skill" },
        { key: "6", text: "打印服务时长", link: "/player/user-report" },
        { key: "7", text: "收货地址", link: "/player/user-address" }
      );
      nodeList.push(
        // (<Route key='1' exact path="/player/rescuedetail/:rescue_id" component={PlayerRescueDetail}/>),
        // (<Route key='2' exact path="/player/rescuelist/:indexno" component={PlayerRescueList}/>),
        // (<Route key='3' exact path="/player/trainlist/:indexno" component={PlayerTrainList}/>),
        // (<Route key='4' exact path="/player/traindetail/:train_id" component={PlayerTrainDetail}/>),
        <Route key="5" exact path="/player/infoedit" component={InfoEdit} />,
        <Route key="6" exact path="/player/uppwd" component={UpPwd} />,
        <Route key="7" exact path="/player/add-skill" component={SkillAdd} />,
        <Route
          key="8"
          exact
          path="/player/user-report"
          component={UserReport}
        />,
        <Route
          key="9"
          exact
          path="/player/user-address"
          component={UserAddress}
        />,
       
      );
    }
    // className="ranks"
    return (
      <MyFrame
        history={this.props.history}
        menuList={menuList}
        menuSelectKey={menu_key}
        siderWidth="10rem"
      >
        <Switch>
          {nodeList}
          {/*<Route exact path="/player/donation/:indexno" component={PlayerDonation}/>*/}
          <Route
            exact
            path="/player/experience/:indexno"
            component={PExperience}
          />
          <Route
            exact
            path="/player/honorwall/:indexno"
            render={(props) => {
              return (
                <TeamHonorWall
                  onBack={() => app.backPage(this)}
                  enter="player"
                  param={props.match.params.indexno}
                />
              );
            }}
          />
          <Route exact path="/player/:team_id/:indexno" component={PMember} />
          {/*<Route exact path="/player/member/:team_id/:indexno" component={PMember}/>*/}
          <Route render={() => <Redirect to="/" />} />
        </Switch>
      </MyFrame>
    );
  }
}

export default PlayerInfo;



// WEBPACK FOOTER //
// ./src/routes/PlayerInfo.jsx